// Phase B Block 2 — «время обработки по конфигам» table.
//
// A plain table, not a chart: per the spec a table reads better than
// a bar chart for the 5-12 config rows this DB carries. The backend
// ships the rows pre-sorted by median ASC (fastest configs first),
// so we render them verbatim — no client-side re-sort.

import type { ProcessingTimeConfigRow } from '../../api/types';
import { formatConfig } from './formatConfig';

export function ProcessingTimeTable({
  rows,
}: {
  rows: ProcessingTimeConfigRow[];
}) {
  if (rows.length === 0) {
    return (
      <div className="proctime-section">
        <div className="section-title">время обработки по конфигам</div>
        <div className="analytics-empty">
          нет завершённых задач с обоими таймстампами
        </div>
      </div>
    );
  }
  return (
    <div className="proctime-section">
      <div className="section-title">время обработки по конфигам (мин)</div>
      <div className="proctime-wrap">
        <table className="proctime-table" data-testid="proctime-table">
          <thead>
            <tr>
              <th className="proctime-th-config">конфиг</th>
              <th>n</th>
              <th>медиана</th>
              <th>среднее</th>
              <th>макс</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.config} data-testid={`proctime-row-${r.config}`}>
                <td className="proctime-config">{formatConfig(r.config)}</td>
                <td className="proctime-num">{r.n}</td>
                <td className="proctime-num proctime-median">
                  {r.median_min.toFixed(1)}
                </td>
                <td className="proctime-num">{r.mean_min.toFixed(1)}</td>
                <td className="proctime-num">{r.max_min.toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
